'use client';

import React, { useEffect } from 'react';

import '@/styles/globals.v2.css';

import cn from '@/helpers/utils/classNames';

import './style.css';

const CartPageActionsButtonContainer = ({ children }: any) => {
  useEffect(() => {
    const currentUrlPathName = window.location.pathname;
    if (currentUrlPathName && currentUrlPathName.includes('/cart')) {
      document.body.classList.add('is-cart-page');
    }
    return () => {
      document.body.classList.remove('is-cart-page');
    };
  }, []);

  return (
    <div
      className={cn(
        'v2-block md:v2-hidden v2-mt-8 v2-px-4 v2-flex v2-flex-col v2-py-5 v2-items-center v2-bg-[#F3F6F5] order_summary_actions_button_container gap-2'
      )}
    >
      {children}
    </div>
  );
};

export default CartPageActionsButtonContainer;
